module.exports = __webpack_public_path__ + "media/v2/statistics-6c588fea.png";